var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { alpha, Chip, Tooltip, useTheme } from "@mui/material";
import { useLayoutEffect, useRef, useState } from "react";
import { PriceChipLabel } from "./PriceChipLabel";
import { defaultItemPriceColor } from "./PriceChip-utls";
import { getAccessibleTextColor } from "../BrandingProvider/mealTrackThemeConfigurations";
export const PriceChip = (_a) => {
    var { itemPrice, itemSalePrice, itemPriceColor = defaultItemPriceColor, style } = _a, rest = __rest(_a, ["itemPrice", "itemSalePrice", "itemPriceColor", "style"]);
    const theme = useTheme();
    const chipTextRef = useRef(null);
    const [isTextOverflowing, setIsTextOverflowing] = useState(false);
    const chipTextColor = theme.palette.common.white;
    const backgroundColor = alpha(itemPriceColor, 0.71);
    const textColor = getAccessibleTextColor(theme, chipTextColor, backgroundColor);
    useLayoutEffect(() => {
        if (chipTextRef.current) {
            setIsTextOverflowing(chipTextRef.current.scrollWidth > chipTextRef.current.clientWidth);
        }
    }, [itemPrice, itemSalePrice]);
    const chip = (_jsx(Chip, Object.assign({ variant: "outlined", label: _jsx(PriceChipLabel, { itemPrice: itemPrice, itemSalePrice: itemSalePrice, textRef: chipTextRef }), sx: Object.assign({ backgroundColor: backgroundColor, borderColor: itemPriceColor, color: textColor }, style) }, rest)));
    return isTextOverflowing ? _jsx(Tooltip, Object.assign({ title: itemPrice }, { children: chip })) : chip;
};
